function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import get from 'lodash/get';
import map from 'lodash/map';
import isObject from 'lodash/isObject';
import times from 'lodash/times';
import Pagination from 'components/Pagination';
import intlShape from 'shapes/intlShape';
import * as shapes from './shapes';
var _React_PureComponent;
class Table extends (_React_PureComponent = React.PureComponent) {
    async onPageChange(page) {
        const { perPage } = this.state;
        if (this.props.onPageChange) await this.props.onPageChange({
            page,
            perPage
        });
        this.setState({
            page
        });
    }
    async onPerPageChange(perPage) {
        const { page } = this.state;
        if (this.props.onPerPageChange) await this.props.onPerPageChange({
            page,
            perPage
        });
        this.setState({
            perPage
        });
    }
    get pagedEntities() {
        const { entities, idKey, isInProgress } = this.props;
        const { page, perPage } = this.state;
        if (isInProgress) {
            return times(perPage, (n)=>({
                    [idKey]: n
                }));
        }
        return entities.slice(perPage * page, perPage * (page + 1));
    }
    get totalPages() {
        const { entities, perPage } = this.props;
        return Math.ceil(entities.length / perPage);
    }
    renderHeaderCell(schemaItem, idx) {
        const { labelMessage = '' } = schemaItem;
        const message = isObject(labelMessage) ? this.props.intl.formatMessage(labelMessage) : labelMessage;
        return /*#__PURE__*/ _jsx("th", {
            className: "table__cell",
            children: message
        }, idx);
    }
    renderHeader() {
        const { schema } = this.props;
        return /*#__PURE__*/ _jsx("thead", {
            className: "table__header",
            children: /*#__PURE__*/ _jsx("tr", {
                className: "table__row",
                children: map(schema, (schemaItem, idx)=>this.renderHeaderCell(schemaItem, idx))
            })
        });
    }
    renderRowCell(entity, entityKey, schemaItem) {
        const { key, renderer } = schemaItem;
        const value = renderer ? renderer(entity) : get(entity, key, '');
        return /*#__PURE__*/ _jsx("td", {
            className: "table__cell",
            children: value
        }, `${entityKey}-${key}`);
    }
    renderRow(entity) {
        const { schema, idKey, isInProgress } = this.props;
        const entityKey = get(entity, idKey);
        return /*#__PURE__*/ _jsx("tr", {
            className: cn('table__row', {
                fadingLoader: isInProgress
            }),
            children: map(schema, (schemaItem)=>this.renderRowCell(entity, entityKey, schemaItem))
        }, entityKey);
    }
    renderBody() {
        return /*#__PURE__*/ _jsx("tbody", {
            children: map(this.pagedEntities, (entity)=>this.renderRow(entity))
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("table", {
                    className: cn('table', this.props.className),
                    children: [
                        this.renderHeader(),
                        this.renderBody()
                    ]
                }),
                /*#__PURE__*/ _jsx(Pagination, {
                    perPage: this.state.perPage,
                    onPerPageChange: (perPage)=>this.onPerPageChange(perPage),
                    onPageChange: (page)=>this.onPageChange(page),
                    page: this.state.page,
                    totalPages: this.totalPages,
                    isPerPageOff: this.props.isPerPageOff
                })
            ]
        });
    }
    constructor(props){
        super(props);
        const { perPage } = props;
        this.state = {
            page: props.page,
            perPage
        };
    }
}
_define_property(Table, "propTypes", {
    // Explicit props
    idKey: PropTypes.string.isRequired,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    schema: shapes.schema.isRequired,
    entities: PropTypes.array.isRequired,
    page: PropTypes.number,
    perPage: PropTypes.number,
    isInProgress: PropTypes.bool,
    isPerPageOff: PropTypes.bool,
    // Explicit actions
    onPageChange: PropTypes.func,
    onPerPageChange: PropTypes.func,
    // Implicit props
    intl: intlShape
});
_define_property(Table, "defaultProps", {
    page: 0,
    perPage: 10
});
export default injectIntl(Table);
